import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, SmallCardButton } from "./../Controls";

const TypeOfProperty: React.FunctionComponent<{
  onSubmit?: (value: TypeOfProperty) => void;
}> = (props: { onSubmit?: (value: TypeOfProperty) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: TypeOfProperty) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            Great! What type of property are you purchasing?
          </h1>
        }
      >
        <div className="form-cardBtns-wrapper form-inputs-wrapper">
          <SmallCardButton
            label="Single Family Home"
            icon={<i className="icon-nbr-main-home"></i>}
            onClick={() => {
              handleSubmit("single family home");
            }}
            anim
            active={
              loanFormContext.typeOfProperty?.value === "single family home"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Townhome"
            icon={<i className="icon-nbr-multi-family"></i>}
            onClick={() => {
              handleSubmit("townhome");
            }}
            anim
            active={
              loanFormContext.typeOfProperty?.value === "townhome"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Condominium"
            icon={<i className="icon-nbr-condo"></i>}
            onClick={() => {
              handleSubmit("condominium");
            }}
            anim
            active={
              loanFormContext.typeOfProperty?.value === "condominium"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Multi Family Home"
            icon={<i className="icon-nbr-townhome"></i>}
            onClick={() => {
              handleSubmit("multi family home");
            }}
            anim
            active={
              loanFormContext.typeOfProperty?.value === "multi family home"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Manufactured or Mobile Home"
            icon={<i className="icon-nbr-mobile-home"></i>}
            onClick={() => {
              handleSubmit("manufactured or mobile home");
            }}
            anim
            active={
              loanFormContext.typeOfProperty?.value ===
              "manufactured or mobile home"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export type TypeOfProperty =
  | "single family home"
  | "townhome"
  | "condominium"
  | "multi family home"
  | "manufactured or mobile home";

export default TypeOfProperty;
